import wretchAdapter from '@/shared/api/adapters/wretch';

export default wretchAdapter(CONFIG.BILLING_SERVICE_API_ROOT);
